import React from 'react'
import './whychoosesentry.scss'
import { Hero, MainHeading, FeaturedBar, PageHeaderIntro, FindAgent, ClaimService , FigureCards, SuccessStories, VideoPlayer , OurExperience } from '../../components';
import { images } from "../../utils/customFn";
import { Container } from 'react-bootstrap';
const WhyChooseSentry = () => {

    // page intro data
    const HeaderData = [
        {
            para: 'Whether you’re an independent local business with one employee, or a large company with locations nationwide and 100,000 employees, we offer you business insurance solutions, our experienced staff, and knowledgeable claims services.',
        },
    ];

    // agent options
    const Selectoptions = [
        { value: 'Constructions', label: 'Constructions' },
        { value: 'DealerShip', label: 'DealerShip' },
        { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
        { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
        { value: 'Service industries', label: 'Service industries' },
        { value: 'Trucking', label: 'Trucking' },
    ];

    // claim card data
    const ClaimData = [
        {
            id: 1,
            title: "Our team of experienced claims professionals is dedicated to serving you.",
            link: "",
            btnText: "About our claims services",
        },
    ];

    //AnnualReportData
    const AnnualReportData = [
        {
            id: 1,
            title: "At Sentry, we’re building for tomorrow—today. Follow our progress.",
            link: "",
            btnText: "2023 Annual Report",
        },
    ];

    //revenue data
    const revenueData = [
        {
          id: 1,
          value: "120+",
          unit: "Years in business",
          description: "Sentry and its predecessor companies have offered insurance coverage to businesses like yours for more than 120 years.",
        },
        {
          id: 2,
          value: "1992",
          unit: "Through 2024",
          description: "1992 was the first year of a long run, now at 33 years, in which Sentry Insurance Group was rated A+ (superior) by AM Best.*",
        },
        {
          id: 3,
          value: "50",
          unit: "States",
          description: "Sentry has business customers like you all through our great nation.",
        },
    ];

    return (
        <>
            <div className='why-choose-sentry-wrapper'>
                {/* hero section */}
                <Hero img={images["hero-why-sentry.avif"]} secimg={images["hero-why-sentry-small.png"]} />
                <Container>

                    {/* heading  */}
                    <MainHeading title="Why choose Sentry" showshare={false} />

                    {/* page intro */}
                    <PageHeaderIntro Data={HeaderData} heading="Hello. We’re Sentry. How can we help you?" showImage={false} />

                    {/* OurExperience */}
                    <OurExperience/>

                    {/* ClaimService cards*/}
                    <ClaimService/>

                    {/* claim Service Card */}
                    <FeaturedBar data={ClaimData} />

                </Container>
                {/* Thank you section */}
                <div className='Thank-you-wrapper'>
                    <Container>
                        <div className='top-details'>
                            <h3>Thank you</h3>
                            <p>For our customers doing right by all of us, working tirelessly to help keep our country running efficiently every day, we thank you. And know that we’ll be Right By You.</p>
                        </div>
                        <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />
                    </Container>
                </div>

                <Container>
                    {/* significant figures */}
                    <FigureCards data={revenueData} heading={'Sentry’s significant figures'}/>

                    {/* Annual report Card */}
                    <FeaturedBar data={AnnualReportData} />

                    {/* success stories */}
                    <SuccessStories/>
                    
                    {/* find agent */}
                    <FindAgent options={Selectoptions}/>
                </Container>
            </div>
        </>
    )
}

export default WhyChooseSentry